import script from "./DashBoardList.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBoardList.vue?vue&type=script&setup=true&lang=js"

import "./DashBoardList.vue?vue&type=style&index=0&id=e8fc8714&lang=css"

const __exports__ = script;

export default __exports__